(function () {
  function initCarousel(sectionEl) {
    if (!sectionEl) return;

    var track = sectionEl.querySelector('[data-carousel-track]');
    var originalSlides = sectionEl.querySelectorAll('[data-carousel-slide]');
    var prevBtn = sectionEl.querySelector('[data-carousel-prev]');
    var nextBtn = sectionEl.querySelector('[data-carousel-next]');
    var dots = sectionEl.querySelectorAll('.oddit-section-reviews-carousel__dot');

    if (!track || originalSlides.length === 0) return;

    var totalReal = originalSlides.length;
    var ACTIVE_CLASS = 'oddit-section-reviews-carousel__card--active';

    // Clone last card to beginning and first card to end for infinite peek
    var lastClone = originalSlides[totalReal - 1].cloneNode(true);
    var firstClone = originalSlides[0].cloneNode(true);
    lastClone.setAttribute('aria-hidden', 'true');
    firstClone.setAttribute('aria-hidden', 'true');
    lastClone.removeAttribute('data-carousel-slide');
    firstClone.removeAttribute('data-carousel-slide');
    lastClone.classList.add('oddit-section-reviews-carousel__card--clone');
    firstClone.classList.add('oddit-section-reviews-carousel__card--clone');
    track.insertBefore(lastClone, track.firstChild);
    track.appendChild(firstClone);

    // All cards in track: [cloneLast, real0, real1, real2, cloneFirst]
    var allCards = track.children;
    var currentReal = 0;

    function setActiveCard(trackIdx) {
      for (var i = 0; i < allCards.length; i++) {
        allCards[i].classList.remove(ACTIVE_CLASS);
      }
      allCards[trackIdx].classList.add(ACTIVE_CLASS);
    }

    function goToTrackIndex(trackIdx, animate) {
      // Set the active class first so dimensions are correct before measuring
      setActiveCard(trackIdx);

      // Force reflow so the browser applies the new widths
      track.offsetHeight;

      var isDesktop = window.innerWidth >= 990;
      var wrapperW = track.parentElement.offsetWidth;

      // On desktop, use known final-state values (1158px card, -38px inactive margins, 0 gap)
      // to avoid reading getComputedStyle mid-transition which can return stale start values
      // and cause the active card to appear off-center by ~38px.
      // On mobile/tablet there are no scale/margin transitions so getComputedStyle is fine.
      var gap = isDesktop ? 0 : (parseFloat(window.getComputedStyle(track).gap) || 0);

      // Sum actual widths + margins of preceding cards to find the active card's left edge
      var cardLeft = 0;
      for (var i = 0; i < trackIdx; i++) {
        var w, ml, mr;
        if (isDesktop) {
          var isActiveCard = allCards[i].classList.contains(ACTIVE_CLASS);
          w = 1158;
          ml = isActiveCard ? 0 : -38;
          mr = isActiveCard ? 0 : -38;
        } else {
          var cs = window.getComputedStyle(allCards[i]);
          w = allCards[i].offsetWidth;
          ml = parseFloat(cs.marginLeft) || 0;
          mr = parseFloat(cs.marginRight) || 0;
        }
        cardLeft += w + ml + mr + gap;
      }

      // Active card always has margin-left: 0 on desktop; read dynamically on mobile/tablet
      if (!isDesktop) {
        var activeCs = window.getComputedStyle(allCards[trackIdx]);
        cardLeft += parseFloat(activeCs.marginLeft) || 0;
      }

      var cardW = isDesktop ? 1158 : allCards[trackIdx].offsetWidth;
      var centerOffset = (wrapperW - cardW) / 2;
      var translateX = cardLeft - centerOffset;

      if (animate === false) {
        track.style.transition = 'none';
      } else {
        track.style.transition = 'transform 0.4s ease';
      }

      track.style.transform = 'translateX(' + (-translateX) + 'px)';

      if (animate === false) {
        track.offsetHeight;
        track.style.transition = 'transform 0.4s ease';
      }
    }

    function goToSlide(realIndex, animate) {
      currentReal = realIndex;

      // Wrap around
      if (currentReal < 0) currentReal = totalReal - 1;
      if (currentReal >= totalReal) currentReal = 0;

      // Track index is realIndex + 1 (because of prepended clone)
      goToTrackIndex(currentReal + 1, animate);

      // Update dots
      for (var i = 0; i < dots.length; i++) {
        if (i === currentReal) {
          dots[i].classList.add('oddit-section-reviews-carousel__dot--active');
        } else {
          dots[i].classList.remove('oddit-section-reviews-carousel__dot--active');
        }
      }
    }

    // Arrow handlers
    function onPrevClick() {
      goToSlide(currentReal - 1);
    }

    function onNextClick() {
      goToSlide(currentReal + 1);
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', onPrevClick);
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', onNextClick);
    }

    // Dot handlers
    function onDotClick(e) {
      var dotEl = e.currentTarget;
      var dotIndex = parseInt(dotEl.getAttribute('data-dot'), 10);
      if (!isNaN(dotIndex)) {
        goToSlide(dotIndex);
      }
    }

    for (var d = 0; d < dots.length; d++) {
      dots[d].addEventListener('click', onDotClick);
    }

    // Touch/swipe
    var touchStartX = 0;

    function onTouchStart(e) {
      touchStartX = e.changedTouches[0].screenX;
    }

    function onTouchEnd(e) {
      var diff = touchStartX - e.changedTouches[0].screenX;
      if (Math.abs(diff) > 50) {
        goToSlide(diff > 0 ? currentReal + 1 : currentReal - 1);
      }
    }

    track.addEventListener('touchstart', onTouchStart, { passive: true });
    track.addEventListener('touchend', onTouchEnd, { passive: true });

    // Resize
    var resizeTimeout;
    function onResize() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function () {
        goToSlide(currentReal, false);
      }, 150);
    }

    window.addEventListener('resize', onResize);

    // Initialize
    goToSlide(0, false);

    // Return cleanup function
    return function destroy() {
      if (prevBtn) prevBtn.removeEventListener('click', onPrevClick);
      if (nextBtn) nextBtn.removeEventListener('click', onNextClick);
      for (var i = 0; i < dots.length; i++) {
        dots[i].removeEventListener('click', onDotClick);
      }
      track.removeEventListener('touchstart', onTouchStart);
      track.removeEventListener('touchend', onTouchEnd);
      window.removeEventListener('resize', onResize);
      clearTimeout(resizeTimeout);

      // Remove clones
      var clones = track.querySelectorAll('.oddit-section-reviews-carousel__card--clone');
      for (var c = 0; c < clones.length; c++) {
        clones[c].parentNode.removeChild(clones[c]);
      }
    };
  }

  // Track active destroyers by section id
  var destroyers = {};

  function initSection(sectionEl) {
    var sectionId = sectionEl.id;
    if (destroyers[sectionId]) {
      destroyers[sectionId]();
      delete destroyers[sectionId];
    }
    var destroy = initCarousel(sectionEl);
    if (destroy) {
      destroyers[sectionId] = destroy;
    }
  }

  // Initialize all instances on page once styles are ready
  function initAll() {
    var sections = document.querySelectorAll('.oddit-section-reviews-carousel');
    for (var s = 0; s < sections.length; s++) {
      initSection(sections[s]);
    }
  }

  // Wait for all assets (styles, fonts) before measuring card widths
  if (document.readyState === 'complete') {
    initAll();
  } else {
    window.addEventListener('load', initAll);
  }

  // Theme editor support
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.oddit-section-reviews-carousel');
    if (el) initSection(el);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var el = e.target.querySelector('.oddit-section-reviews-carousel');
    if (el && destroyers[el.id]) {
      destroyers[el.id]();
      delete destroyers[el.id];
    }
  });
})();
